import { render } from "./OpportunityApplications.vue?vue&type=template&id=20fd0e7c&scoped=true"
import script from "./OpportunityApplications.vue?vue&type=script&lang=js"
export * from "./OpportunityApplications.vue?vue&type=script&lang=js"

import "./OpportunityApplications.vue?vue&type=style&index=0&id=20fd0e7c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20fd0e7c"

export default script